module.exports = __webpack_public_path__ + "img/084d4af.png";